<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:divider>
            <v-icon>mdi-forward</v-icon>
          </template>
        </v-breadcrumbs>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-school-outline</v-icon>
            Learner Syllabus Progress
          </v-card-title>

          <v-card-text class="pa-0">
            <v-tabs
              v-model="activeTab"
              background-color="grey lighten-4"
              color="primary"
              show-arrows
            >
              <v-tab href="#tab-enrolments">
                <v-icon left small>mdi-account-group</v-icon>
                Enrolments
              </v-tab>
              <v-tab href="#tab-enrol">
                <v-icon left small>mdi-account-plus</v-icon>
                Enrol Learner
              </v-tab>
              <v-tab href="#tab-progress">
                <v-icon left small>mdi-chart-line</v-icon>
                Progress
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item value="tab-enrolments">
                <v-container class="pa-4">
                  <EnrolmentList
                    :items="getEnrolments"
                    :loading="!isEnrolmentsLoaded"
                    :instructors="uniqueInstructors"
                    @view-progress="onViewProgress"
                  />
                </v-container>
              </v-tab-item>

              <v-tab-item value="tab-enrol">
                <v-container class="pa-4">
                  <EnrolLearnerForm
                    :syllabuses="activeSyllabuses"
                    @enrolled="onEnrolled"
                  />
                </v-container>
              </v-tab-item>

              <v-tab-item value="tab-progress">
                <v-container class="pa-4">
                  <ProgressPanel
                    :enrollment="selectedEnrolment"
                    :enrolments="getEnrolments"
                    @select-enrolment="onEnrolmentSelected"
                  />
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  M_OU,
  LOAD_SYLLABUS_ENROLMENT_LIST,
  GET_SYLLABUS_ENROLMENT_LIST,
  IS_SYLLABUS_ENROLMENT_LIST_LOADED,
  GET_SYLLABUS_LIST,
  IS_SYLLABUS_LIST_LOADED,
  LOAD_ACTIVE_INSTRUCTORS,
  IS_ACTIVE_INSTRUCTORS_LOADED,
  LOAD_SYLLABUS_LIST,
  IS_SKILL_LIST_LOADED,
  IS_STEP_LIST_LOADED,
  LOAD_SKILL_LIST,
  LOAD_STEP_LIST,
} from "@/store/mutation-list";

import EnrolmentList from "@/components/Syllabus/EnrolmentList.vue";
import EnrolLearnerForm from "@/components/Syllabus/EnrolLearnerForm.vue";
import ProgressPanel from "@/components/Syllabus/ProgressPanel.vue";

export default {
  name: "LearnerProgress",
  components: { EnrolmentList, EnrolLearnerForm, ProgressPanel },

  data() {
    return {
      activeTab: "tab-enrolments",
      selectedEnrolment: null,
      breadcrumbs: [
        { text: "Dashboard", disabled: false, href: "/dashboard/home" },
        {
          text: "Learner Progress",
          disabled: true,
          href: "/dashboard/learnerprogress",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      getEnrolments: `${M_OU}${GET_SYLLABUS_ENROLMENT_LIST}`,
      isEnrolmentsLoaded: `${M_OU}${IS_SYLLABUS_ENROLMENT_LIST_LOADED}`,
      getSyllabuses: `${M_OU}${GET_SYLLABUS_LIST}`,
      isSyllabusLoaded: `${M_OU}${IS_SYLLABUS_LIST_LOADED}`,
      isInstructorsLoaded: `${M_OU}${IS_ACTIVE_INSTRUCTORS_LOADED}`,
      isSkillsLoaded: `${M_OU}${IS_SKILL_LIST_LOADED}`,
      isStepsLoaded: `${M_OU}${IS_STEP_LIST_LOADED}`,
    }),

    activeSyllabuses() {
      return this.getSyllabuses.filter((s) => s.status === 1);
    },

    uniqueInstructors() {
      const map = new Map();
      this.getEnrolments.forEach((e) => {
        if (!map.has(e.adi_id)) {
          map.set(e.adi_id, { adi_id: e.adi_id, adi: e.adi });
        }
      });
      return [...map.values()];
    },
  },

  methods: {
    ...mapActions({
      loadEnrolments: `${M_OU}${LOAD_SYLLABUS_ENROLMENT_LIST}`,
      loadActiveInstructors: `${M_OU}${LOAD_ACTIVE_INSTRUCTORS}`,
      loadSyllabuses: `${M_OU}${LOAD_SYLLABUS_LIST}`,
      loadSkills: `${M_OU}${LOAD_SKILL_LIST}`,
      loadSteps: `${M_OU}${LOAD_STEP_LIST}`,
    }),

    onViewProgress(enrolment) {
      this.selectedEnrolment = enrolment;
      this.activeTab = "tab-progress";
    },

    onEnrolmentSelected(enrolment) {
      this.selectedEnrolment = enrolment;
    },

    onEnrolled() {
      this.loadEnrolments();
    },
  },

  created() {
    if (!this.isEnrolmentsLoaded) this.loadEnrolments();
    if (!this.isInstructorsLoaded) this.loadActiveInstructors();
    if (!this.isSyllabusLoaded) this.loadSyllabuses();
    if (!this.isSkillsLoaded) this.loadSkills();
    if (!this.isStepsLoaded) this.loadSteps();
  },
};
</script>
